import React from "react";
import AnimatedText from "./AnimatedText";
import EnquiryForm from "../enquiryForm";

const Enquire = () => {
  return (
    <div className="bg-white flex flex-col items-center w-full min-h-[700px] bg-enquire h-full">
      <div className="h-full relative max-w-screen-xl flex flex-wrap md:items-start items-center flex-col md:flex-row w-full">
        <div className="w-full md:w-1/2 flex flex-col gap-8 items-center justify-start mt-5 md:mt-[60px] pl-8 pr-10 h-full py-5 md:py-0">
          <p className="md:text-5xl text-2xl mb-1 md:mb-0">
            Ready to experience the
          </p>
          <AnimatedText text="Clear&nbsp;Choice" />
          <p className="text-5xl">difference ?</p>
          <p className="text-xl text-center">
            Our team is here to help! Fill out the form, and we'll get back to
            you promptly with the information you need.
          </p>
        </div>
        <div className="w-full md:w-1/2 flex flex-col gap-8 items-center justify-center bg-blue-6 h-full py-10 px-5 xl:px-0">
          <p className="text-6xl uppercase text-white my-4">Inquire Now</p>
          <EnquiryForm />
        </div>
      </div>
    </div>
  );
};

export default Enquire;
